import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddOffer from './components/AddOffer';
import '../../styles/products.scss';

const OfferEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier l\'Offre');
  }, [setTitle]);

  return (
    <div className="offer-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddOffer isEdit={true} offerId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default OfferEdit;
